import {SessionStorageService} from './session-storage.service';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class HasPermissionGuard implements CanActivate {

    constructor(public sessionStorageService: SessionStorageService, private router: Router) {
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        const accessModule = this.sessionStorageService.getModulePermissionSession();
        if (next['data']['data'] != undefined) {
            const success = accessModule.indexOf(next['data']['data']['id']);
            if (success != -1 || next['data']['data']['id'] == 0) {
                return true;
            } else {
                this.router.navigate(['/others/404']);
                return false;
            }
        } else {
            return true;
        }
    }
}
